import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import * as styles from "./testimonialVideo.module.css";

const TestimonialVideo = ({
  node,
  clickHandler,
  bgColor,
  titleColor,
  watchColor,
}) => {
  const { testimonialVideoText, testimonialVideoImage } = node;
  let videoImage = "";
  if (testimonialVideoImage && testimonialVideoImage.asset) {
    videoImage = testimonialVideoImage.asset.url;
  }
  return (
    <Box
      className={styles.testimonialBox}
      style={{ backgroundColor: bgColor }}
      onClick={clickHandler}
    >
      <Grid container>
        <Grid item md={12}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <img width={"100%"} height={"60px"} src={videoImage} />
            </Grid>
            <Grid item xs={8}>
              <Box mb={1}>
                <h3
                  className={styles.testimonialVideoTitle}
                  style={{ color: titleColor }}
                >
                  {testimonialVideoText}
                </h3>
              </Box>
              <Box>
                <p
                  className={styles.testimonialVideoWatchText}
                  style={{ color: watchColor }}
                >
                  Watch Now
                </p>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TestimonialVideo;
